import { render, staticRenderFns } from "./QRadioGroup.vue?vue&type=template&id=875b650e&"
import script from "./QRadioGroup.vue?vue&type=script&lang=js&"
export * from "./QRadioGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports